import { forwardRef } from '@heroui/system';
import { Calendar, CalendarProps } from '@heroui/react';

export interface CustomCalendarProps extends CalendarProps {}

const CustomCalendar = forwardRef<'div', CustomCalendarProps>((props, ref) => {
  return (
    <Calendar
      ref={ref}
      aria-label="Calendar"
      classNames={{
        base: 'tmdx-calendar bg-base-60 shadow-xl',
      }}
      calendarWidth="16.25rem"
      {...props}
    />
  );
});

CustomCalendar.displayName = 'CustomCalendar';

export default CustomCalendar;
